import { render, staticRenderFns } from "./labelGroup.vue?vue&type=template&id=429eb6a1&scoped=true"
import script from "./labelGroup.vue?vue&type=script&lang=js"
export * from "./labelGroup.vue?vue&type=script&lang=js"
import style0 from "./labelGroup.vue?vue&type=style&index=0&id=429eb6a1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "429eb6a1",
  null
  
)

export default component.exports